module.exports = __webpack_public_path__ + "static/media/logo.216e0ba8.svg";